import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext"; 
import MonoButton from "./MonoButton";
import ICONS, { ICON_COLORS } from "../config/icon";
import ChangeCourseDateModal from "./ChangeCourseDateModal";
import PdfSignerModal from "./PdfSignerModal";

function CourseCardDashboard({ course }) {
  const { userId } = useAuth();
  const [openSigner, setOpenSigner] = useState(false);

  // Icon-Setup
  const Icon = ICONS[course.iconName] || ICONS.default;
  const colorClass = ICON_COLORS[course.iconName] || ICON_COLORS.default;

  // Startdatum ermitteln
  const formattedDate =
    course.customDate && course.customDate !== "null"
      ? new Date(course.customDate).toLocaleDateString("de-DE")
      : course.startDate
      ? new Date(course.startDate).toLocaleDateString("de-DE")
      : "Noch nicht festgelegt";

  // PDF-URLs
  const pdfUrl = course.pdfPath ? `https://www.denisbitter.de/stage01/uploads/${course.pdfPath}` : null;
  const pdfUrlSigned = course.pdfPathSigned
    ? `https://www.denisbitter.de/stage01/uploads/signed/${course.pdfPathSigned}`
    : null;

  // -- NEU: Alle wichtigen Infos im Link mitgeben
  const queryParams = new URLSearchParams({
    user: userId,
    registration: course.registrationId,
    title: course.title,
    date: formattedDate
  }).toString();

  return (
    <div>
      <div className="bg-gray-50 border border-gray-800 rounded-xl p-6 flex flex-col h-full font-mono shadow-md mb-6">
        <div className="flex items-start space-x-4 mb-4">
          <div className="flex-shrink-0 text-gray-900">
            {Icon && <Icon className={`w-6 h-6 ${colorClass}`} />}
          </div>
          <div className="text-left">
            <h3 className="text-lg font-bold text-gray-900 mb-2">{course.title}</h3>
            <p className="text-xs font-semibold text-gray-800 bg-brand px-2 pt-2 pb-2 rounded-md">
              Start: {formattedDate}
            </p>
          </div>
        </div>

        {/* Beschreibung */}
        {Array.isArray(course.description) ? (
          <ul className="text-xs text-left text-gray-700 mb-4 list-disc pl-5">
            {course.description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-left text-gray-700 mb-4">
            {course.description || "Keine Beschreibung verfügbar."}
          </p>
        )}

        <div className="flex flex-col space-y-2">
          {/* Kurs Cockpit-Link mit Query-String */}
          <Link
            to={`/coursecockpit/${course.id}?${queryParams}`}
          >
            <MonoButton className="w-full text-xs">Dein Kurs Cockpit</MonoButton>
          </Link>

          {/* Modal zum Datum ändern */}
          <ChangeCourseDateModal registrationId={course.id} />

          {/* PDF Download */}
          {pdfUrl && (
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-block"
            >
              <MonoButton className="w-full text-xs text-center">
                PDF herunterladen
              </MonoButton>
            </a>
          )}

          {/* Signiertes PDF */}
          {pdfUrlSigned ? (
            <a
              href={pdfUrlSigned}
              className="block text-center underline text-xs text-green-700 font-semibold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Signiertes PDF ansehen
            </a>
          ) : (
            <>
              <MonoButton
                onClick={() => setOpenSigner(true)}
                className="text-xs w-full"
              >
                Jetzt digital unterschreiben
              </MonoButton>

              <PdfSignerModal
                isOpen={openSigner}
                onClose={() => setOpenSigner(false)}
                pdfUrl={pdfUrl}
                onSigned={() => {
                  setOpenSigner(false);
                  window.location.reload();
                }}
                userId={userId}
                course={course.slug}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CourseCardDashboard;
